import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { useVocabularyData } from 'app/utils/vocabulary'
import React, { memo, useContext } from 'react'

import { FooterContext } from './index'

export const Credits = memo(function Credits() {
  const { languageCode } = useContext(FooterContext) as any

  return (
    <Container dial={4} row space="between" tag="section" wrap>
      <LeftSide>{useVocabularyData('footer-text', languageCode)}</LeftSide>

      <RightSide dial={6} row>
        <Logo
          alt="Unione Europea"
          src="/footer-logo-1.png"
          width="100"
          height="84"
        />
        <Logo
          alt="Ministero del Turismo"
          src="/footer-logo-2.png"
          width="167"
          height="120"
        />
        <Logo alt="iFit" src="/footer-logo-3.png" width="109" height="84" />
      </RightSide>
    </Container>
  )
})

const Container = styled(FlexBox)`
  background: ${({ theme }) => theme.colors.variants.neutralLight5};
  padding: 1.875rem 8.333vw;

  @media (max-width: 1199px) {
    padding: 1.875rem;
  }
`

const LeftSide = styled.div`
  max-width: 29.5625rem;
  color: ${({ theme }) => theme.colors.variants.neutralDark2};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 0.875rem;
  font-weight: 300;
  line-height: 1.25rem;

  @media (max-width: 1199px) {
    width: 100%;
    max-width: none;
    text-align: center;
  }
`

const RightSide = styled(FlexBox)`
  @media (max-width: 1199px) {
    width: 100%;
    justify-content: center;
    margin-top: 1rem;
  }
`

const Logo = styled.img`
  margin-right: 0.625rem;
  &:last-of-type {
    margin-right: 0;
  }

  @media (max-width: 1199px) {
    margin: 0 0.1875rem;
    &:last-of-type {
      margin-right: 0.1875rem;
    }
  }

  @media (max-width: 767px) {
    max-width: 33.333%;
    height: auto;
  }
`
